import React, { useState } from 'react'
import {localestr} from '../utils.js'
import EditDateTime from './EditDateTime.js';


function RangeForm({from,to,setModal,action}){
    const [frm,setFrom]=useState(from)
    const [to_,setTo]=useState(to)

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function setRange(val){
      let d1=new Date()
      let d2=new Date()
      d1.setHours(0,0,0,0)
      d2.setHours(23,59,59,999)
      if(val==='yesterday'){
        d1.setDate(d1.getDate()-1)
        d2.setDate(d2.getDate()-1)
      } else if(val==='currweek'){
        let d3=d1.getDay()-1
        if (d3===-1) d3=6
        d1.setDate(d1.getDate()-d3)
      } else if(val==='lastweek'){
        let d3=d1.getDay()
        if (d3===0) d3=7
        d2.setDate(d1.getDate()-d3)
        d1.setDate(d2.getDate()-6)
      } else if(val==='currmonth'){
        d1.setDate(1)
      } else if(val==='lastmonth'){
        d2.setDate(0)
        d1.setMonth(d1.getMonth()-1,1)
      }
      setFrom(d1)
      setTo(d2)
    }

    /*function toDate(d){
      return new Date(d)
    }*/

    function fromDate(d){
      return d.getFullYear()+'-'+(d.getMonth() + 1).toString().padStart(2, '0')+'-'+d.getDate().toString().padStart(2, '0')+'T'+d.getHours().toString().padStart(2, '0')+':'+d.getMinutes().toString().padStart(2, '0')
    }

    function dragMouseDown(e) {
      e = e || window.event;
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }
    
    function elementDrag(e) {
      const elmnt=document.getElementById('modalWnd')
      e = e || window.event;
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      if (pos2!==0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
    
    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }

    return(
        <div className='modal'><div id='modalWnd' className='window'>
            <div onMouseDown={dragMouseDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{localestr('Інтервал дат')}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
            <div className='content' style={{overflow:'unset'}}>
            <div style={{margin:'5px 0 0 0',display:'flex',justifyContent:'center'}}>
            <label style={{display:'inline-flex', margin:'inherit', flexGrow:'180', maxWidth:'360px'}} htmlFor="id1">
              <div style={{display:'inline-flex', minWidth:'20px', lineHeight:'24px', flexBasis:'20px', flexGrow:'10'}}>{localestr('з')} </div>
              <EditDateTime style={{display:'inline-flex', width:'160px', boxSizing:'border-box', height:'24px', flexBasis:'160px', flexGrow:'160'}} id={'id1'} Value={fromDate(frm)}  setVal={setFrom} />
            </label>
            <label style={{display:'inline-flex', margin:'inherit', flexGrow:'180', maxWidth:'360px'}} htmlFor="id2">
              <div style={{display:'inline-flex', minWidth:'20px', lineHeight:'24px', flexBasis:'20px', flexGrow:'10'}}>{localestr('по')} </div>
              <EditDateTime style={{display:'inline-flex', width:'160px', boxSizing:'border-box', height:'24px', flexBasis:'160px', flexGrow:'160'}} id={'id2'} Value={fromDate(to_)}  setVal={setTo} />
            </label>
            </div>
            <div style={{margin:'5px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'130px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setRange('today')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Сьогодні')}</div></div>
            <div style={{width:'130px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setRange('currweek')}}><div style={{height:'30px',lineHeight:'15px',display:'block'}}>{localestr('Поточний тиждень')}</div></div>
            <div style={{width:'130px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setRange('currmonth')}}><div style={{height:'30px',lineHeight:'15px',display:'block'}}>{localestr('Поточний місяць')}</div></div>
            </div>
            <div style={{margin:'5px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'130px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setRange('yesterday')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Вчора')}</div></div>
            <div style={{width:'130px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setRange('lastweek')}}><div style={{height:'30px',lineHeight:'15px',display:'block'}}>{localestr('Минулий тиждень')}</div></div>
            <div style={{width:'130px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setRange('lastmonth')}}><div style={{height:'30px',lineHeight:'15px',display:'block'}}>{localestr('Минулий місяць')}</div></div>
            </div>
            <div style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{action(frm,to_);setModal('')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Закрити')}</div></div>
            </div>
            
            </div>
        </div></div>
    )
}

export default RangeForm